import React, { Fragment, useEffect } from 'react'
import MultiCarouselProduct from './MultiCarouselProduct';
import { useSelector, useDispatch } from 'react-redux';
import { toggleFavorite } from '../Actions/FavoriteIcon.action';

const FavoriteProducts = () => {    
    const products = useSelector((state) => state.favoriteProducts.products);       

    return (<Fragment>    
        {products && products.length > 0 && <div className="favorite__list">
            <div className="favorite__list-container row product-list">
                {products.map((item, index) => {
                    return (
                        <div key={index} className="product-list__item columns small-6 medium-4 large-3">
                            <MultiCarouselProduct item={item} 
                                                index={index} />
                        </div>
                    )
                })}
            </div>
        </div>
        }
    </Fragment >)
}

export default FavoriteProducts;

